<template>
    <div>
        <loading :active.sync="isLoaderVisible"></loading>
        <div class="form-group" :class="{'has-error': errors.has('branchId') }">
            <label for="branchId" class="col-sm-2 control-label">Branch:</label>
            <div class="col-sm-4">
                <branch-picker v-validate.disable="'required'" name="branchId" v-model="timeEntry.branchId" :is-outlook="isOutlook">
                </branch-picker>
                <p class="text-danger" v-if="errors.has('branchId')">{{ errors.first('branchId') }}</p>
            </div>
        </div>
        <div class="form-group" :class="{'has-error': errors.has('fileId') || fileIdErrorMessage}">
            <label for="fileId" class="col-sm-2 control-label">KA Claim #:</label>
            <div class="col-sm-4">
                <input v-validate.disable="'required'" type="number" class="form-control" id="fileId" name="fileId" data-vv-as="KA Claim #"
                       v-model="timeEntry.fileId" @blur="getFile" placeholder="Enter the KA claim number this T&E entry is for." />
                <p class="text-danger" v-if="errors.has('fileId')">{{ errors.first('fileId') }}</p>
                <p class="text-danger" v-if="fileIdErrorMessage && !errors.has('fileId')">{{ fileIdErrorMessage }}</p>
            </div>
        </div>
        <div class="form-group">
            <label for="fileId" class="col-sm-2 control-label">Insured:</label>
            <div class="col-sm-4">
                <span class="insured-company">{{timeEntry.insuredCompany}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import axios from 'axios';
    import Loading from 'vue-loading-overlay';
    import BranchPicker from "./branch-picker";

    Vue.component("branch-picker", BranchPicker);

    export default {
        inject: ['$validator'],
        data: function () {
            return {
                timeEntry: this.$store.state.timeEntry,
                isLoaderVisible: false,
                fileIdErrorMessage: "",
            };
        },
        props: {
            isOutlook: Boolean
        },
        components: { Loading },
        methods: {
            getFile() {
                this.isLoaderVisible = true;
                this.fileIdErrorMessage = "";
                let self = this;
                var url = `/core/api`
                var authHeader = "";
                if (this.isOutlook) {
                    url = this.$store.state.keaUrl + url + `/claims/${this.timeEntry.branchId}/${this.timeEntry.fileId}`
                    authHeader = { headers: { "Authorization": "Bearer " + this.$store.state.accessToken } };
                } else {
                    url += `/claims/${this.timeEntry.branchId}/${this.timeEntry.fileId}`
                }
                axios.get(url, authHeader)
                    .then(response => {
                        self.isLoaderVisible = false;
                        let claim = response.data.claim;
                        let isWholeFoodsParentIncident = response.data.isWholeFoodsParentIncident;
                        let kaClaimNumber = response.data.kaClaimNumber;
                        this.timeEntry.insuredCompany = claim.insuredCompany;
                        this.timeEntry.reportCycle = claim.reportCycle;
                        if (claim.isClosed) {
                            vm.$snotify.warning('This claim is closed. If you are entering a code other than AR or non-billable, you will need to reopen the claim.', 'Closed Claim', {
                                timeout: 0,
                                showProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true,
                                buttons: [
                                    { text: 'OK', action: (toast) => { vm.$snotify.remove(toast.id); }},
                                ]
                            });
                        }
                        self.$store.state.isClosed = claim.isClosed;
                        self.$store.state.fileId = this.timeEntry.fileId;
                        self.$store.state.branchId = this.timeEntry.branchId;
                        self.$store.state.isValidFileId = true;
                        self.$store.state.isWholeFoodsParentIncident = isWholeFoodsParentIncident;
                        self.$store.state.kaClaimNumber = kaClaimNumber;
                        self.$store.state.claimAdjuster = claim.adjuster.trim();
                        self.$store.state.lastReportNumber = response.data.lastReportNumber;
                        self.$store.state.reportCycle = response.data.reportCycle;
                        self.$store.state.abeyanceOffset = response.data.abeyanceOffset;
                    })
                    .catch(function (error) {
                        self.isLoaderVisible = false;
                        self.$store.state.isValidFileId = false;
                        self.$store.state.isWholeFoodsParentIncident = false;
                        self.$store.state.kaClaimNumber = "";
                        if (error.response.status === 404) {
                            self.fileIdErrorMessage = "Claim does not exist.";
                        }
                        else if (error.response.status === 403) {
                            self.fileIdErrorMessage = "Claim access is denied.";
                        }
                        else {
                            self.fileIdErrorMessage = error.response.statusText
                        }
                        self.errors.add({ field: "fileId", msg: self.fileIdErrorMessage });
                    });
            },
        },
        watch: {
            // watch branch change and get the file again
            'timeEntry.branchId': function (newVal, oldVal) {
                if (this.timeEntry.branchId && this.timeEntry.fileId) {
                    this.getFile();
                }
            }
        }
    };
</script>

<style lang="scss">

    .insured-company {
        margin-top: 7px;
        display: block
    }
    .snotifyToast__body {
        width: 100%;
    }

</style>